// extracted by mini-css-extract-plugin
module.exports =  {"productImage":"mnwkXs","productBadge":"g0JXsR","badge":"wZKV62","defaultImage":"r6o_wj"};